import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="relative w-full overflow-hidden bg-green-deep py-20 sm:py-28" data-id="element-43" data-mp="c6slrkigseef">
      <div className="pointer-events-none absolute -left-20 top-10 h-64 w-64 rounded-full bg-green-brand/30 blur-3xl" data-id="element-44" data-mp="c4fv8iyn4vpr" />
      <div className="pointer-events-none absolute -right-16 bottom-0 h-72 w-72 rounded-full bg-yellow-brand/20 blur-3xl" data-id="element-45" data-mp="m4ouy6rucz9w" />

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.6
    }} className="relative mx-auto max-w-3xl px-5 text-center" data-id="element-46" data-mp="h4u42382g9ou">
        <span className="inline-block rounded-full bg-white/10 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-yellow-brand" data-id="element-47" data-mp="14vg16zgj89k2">
          Última llamada
        </span>
        <h2 className="mt-5 font-display text-3xl font-black leading-tight text-white sm:text-4xl lg:text-5xl" data-id="element-48" data-mp="zuiimlrm1di1">
          Simplificá tu rutina y despedite del{' '}
          <span className="text-yellow-brand" data-id="element-49" data-mp="2h4j0ywvdbqpo">“¿qué cocino hoy?”</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-white/80" data-id="element-50" data-mp="2m1sy6yp016o2">
          Accedé ahora a La Guía de las Viandas Escolares: 250 recetas nutritivas y
          deliciosas aprobadas por los chicos, con 50% OFF y todos los bonos incluidos.
        </p>

        <div className="mt-9 flex justify-center" data-id="element-51" data-mp="302c3vz5zs0n2">
          <CTAButton data-id="element-52" data-mp="3010zbx4q2ouw">Acceder ahora con 50% OFF</CTAButton>
        </div>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-white/70" data-id="element-53" data-mp="34t299cef43hr">
          <span className="inline-flex items-center gap-1.5" data-id="element-54" data-mp="39rvp3bh6g6l3">
            <CheckCircleIcon className="h-4 w-4 text-yellow-brand" data-id="element-55" data-mp="3es1gqrng5t36" /> Acceso inmediato
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-56" data-mp="3isbp2aypovl7">
            <CheckCircleIcon className="h-4 w-4 text-yellow-brand" data-id="element-57" data-mp="3iqqskfsu72kp" /> Garantía de 7 días
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-58" data-mp="1ep8pzqmll87s">
            <CheckCircleIcon className="h-4 w-4 text-yellow-brand" data-id="element-59" data-mp="1eqtmhlsh318a" /> Pago 100% seguro
          </span>
        </div>
      </motion.div>
    </section>;
}